import React, { useState } from "react";
import { Button } from "react-bootstrap";

// This component renders a section where user can perform buld process on select rows
// in Ag-Grid. For example, one can compile a list of selected applicant's emails into a
// comma separated list.
function OperateOnSelectedRows(props) {
  const { gridApi } = props;
  const [selectedRows, setSelectedRows] = useState([]);
  const [showSelectedRows, setShowSelectedRows] = useState(false);

  const fetchSelectedRows = (event) => {
    event.preventDefault();
    const selectedNodes = gridApi.getSelectedNodes();
    const selectedData = selectedNodes.map((node) => node.data);
    setSelectedRows(selectedData);
    setShowSelectedRows(true);
  };

  const toggleSelected = (event) => {
    event.preventDefault();
    if (!event.target.open) {
      setShowSelectedRows(false);
    }
  };

  const exportToCSV = (event) => {
    event.preventDefault();
    gridApi.exportDataAsCsv({
      allColumns: true,
      skipColumnGroupHeaders: true,
      skipPinnedTop: true,
      skipPinnedBottom: true,
      onlySelected: true,
      fileName: `Selected-Applications-ts${Date.now()}.csv`,
    });
  };

  return (
    <>
      <Button variant={"primary"} size={"sm"} onClick={fetchSelectedRows}>
        Compile Emails of Selected Applicants
      </Button>
      <br />
      <details open={showSelectedRows} onToggle={toggleSelected}>
        <summary>Output</summary>
        {/*<pre>{JSON.stringify(selectedRows, null, 2)}</pre>*/}
        <pre style={{ whiteSpace: "pre-wrap" }}>
          {selectedRows.map((row) => {
            return row.email + ", ";
          })}
        </pre>
      </details>
      <hr />
      <br />
      <Button variant={"primary"} size={"sm"} onClick={exportToCSV}>
        Export Selected Applications to CSV
      </Button>
      <br />
    </>
  );
}

export default OperateOnSelectedRows;
